import generalUpload from "../_section/upload.class";

export class userLoanStatementUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}
const template= {
    items: [
        {
            name: 'iban',
            label: 'IBAN',
            type: 'text',
            scan: 'iban',
            optional: true
        }, {
            name: 'openingBalance',
            label: 'Opening Balance',
            type: 'currency',
            scan: 'openingBalance',
            optional: true
        }, {
            name: 'closingBalance',
            label: 'Closing Balance',
            type: 'currency',
            scan: 'closingBalance'
        }, {
            name: 'startDate',
            label: 'Start Date',
            type: 'date',
            scan: 'startDate'
        }, {
            name: 'endDate',
            label: 'End Date',
            type: 'date',
            scan: 'endDate',
        }, {
            name: 'monthlyPayment',
            label: 'Monthly Payment',
            type: 'currency',
        },
    ]
}
export class adminLoanStatementUpload extends userLoanStatementUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.endDate) {
            this.setDateData({
                dated: this.values.endDate,
                range:{
                    from: {date: this.values.startDate},
                    to: {date: this.values.endDate},
                },
                expires: this.values.endDate.add('1','year'),
            })
        }
    }
}
